<template>
  <v-list dense nav class="py-0">
    <v-list-item link exact :to="{ name: 'Home' }">
      <v-list-item-icon>
        <v-icon>mdi-home</v-icon>
      </v-list-item-icon>

      <v-list-item-content>
        <v-list-item-title>Home</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <!--<v-subheader>-->
      <!--subheader template-->
    <!--</v-subheader>-->

    <v-list-group>
      <template v-slot:activator>
        <v-list-item-icon
          ><v-icon>mdi-book-open-page-variant</v-icon></v-list-item-icon
        >
        <v-list-item-title>Pages</v-list-item-title>
      </template>

      <v-list-item link exact :to="{ name: 'Help' }">
        <v-list-item-icon>
          <v-icon>mdi-account-question</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Help</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link exact :to="{ name: 'Report' }">
        <v-list-item-icon>
          <v-icon>mdi-bug</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Report Bug/Request Feature</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link exact :to="{ name: 'About' }">
        <v-list-item-icon>
          <v-icon>mdi-help-circle-outline</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>About This Site</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-group>

    <v-list-group>
      <template v-slot:activator>
        <v-list-item-icon
          ><v-icon>mdi-desktop-classic</v-icon></v-list-item-icon
        >
        <v-list-item-title>System</v-list-item-title>
      </template>

      <v-list-item link @click="openSessionDialog">
        <v-list-item-icon>
          <v-icon>mdi-content-save</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Save/Load </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-group>

    <v-list-group>
      <template v-slot:activator>
        <v-list-item-icon
          ><v-icon>mdi-strategy</v-icon></v-list-item-icon
        >
        <v-list-item-title>Moves</v-list-item-title>
      </template>

      <v-list-item v-for="move in moves" :key="move.id" @click="openMakeMovesDialog(move.id)">
        <v-list-item-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ move.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-group>

    <v-list-group>
      <template v-slot:activator>
        <v-list-item-icon
          ><v-icon>mdi-crystal-ball</v-icon></v-list-item-icon
        >
        <v-list-item-title>Oracles</v-list-item-title>
      </template>

      <v-list-item>
        <v-list-item-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Oracles list coming soon</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-group>


    <MakeMoveDialog v-if="selectedMoveID" v-model="makeMovesDialogOpen" :moveID="selectedMoveID" />
    <OraclesDialog v-model="oraclesDialogOpen" />
    <SessionDialog v-model="sessionDialogOpen" />
  </v-list>
</template>

<script>
  import SessionDialog from '@/components/SessionDialog';
  import MakeMoveDialog from '@/components/MakeMoveDialog';
  import OraclesDialog from '@/components/OraclesDialog';

  import {mapState, mapGetters} from 'vuex';

  export default {
    data() {
      return {
        sessionDialogOpen: false,
        makeMovesDialogOpen: false,
        oraclesDialogOpen: false,
        selectedMoveID: null,
      };
    },
    computed: {
      ...mapState('move', ['moves', 'movesCategories']),
      ...mapGetters('move', ['moveByID']),
    },
    methods: {
      openSessionDialog() {
        //this.navOpen = false;
        this.sessionDialogOpen = true;
      },
      openMakeMovesDialog(id) {
        this.selectedMoveID = id
        this.makeMovesDialogOpen = true;
      },
      openOraclesDialog() {
        this.oraclesDialogOpen = true;
      },
    },
    components: {
      SessionDialog,
      MakeMoveDialog,
      OraclesDialog,
    },
  };
</script>
